import { render } from "./9-nights.vue?vue&type=template&id=6b4eb915&scoped=true"
import script from "./9-nights.vue?vue&type=script&lang=js"
export * from "./9-nights.vue?vue&type=script&lang=js"

import "./9-nights.vue?vue&type=style&index=0&id=6b4eb915&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4eb915"]])

export default __exports__